import { useParams } from "react-router";
import styled from "styled-components";

import Delete from "./components/Delete";
import { BIMClass, Parameter } from "../../../../modules/shared-entities";
import Back from "../../components/Back";
import Background from "../../components/Background";
import Box from "../../components/Box";
import RevitBuiltInParameter from "../RevitBuiltInParameter/RevitBuiltInParameter";
import SharedParameterAttributes from "./components/SharedParameterAttributes";
import useRevitParameterTemplate from "./useRevitParameterTemplate";

import type { ElementType } from "react";

const Styled = styled(Box)`
    color: #000;
    flex-direction: row;
    gap: 32px;

    & > span {
        align-self: center;
        font-family: var(--font-mono);
        font-size: 1rem;
    }
`;

function RevitBuiltInParameterAssignment(props) {
    return (
        <Styled name="built-in">
            <span>When inserting into Revit,<br />Revit Built-In Parameter will be used</span>
            <RevitBuiltInParameter { ...props } />
        </Styled>
    );
}

const StyledDetail = styled.div`
    align-items: flex-start;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 8vh max(64px, 8vw);

    & > a {
        margin-top: 8px;
    }

    & > header {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        font-size: 1.6rem;
        gap: 16px;

        & > * {
            flex: none;
        }
    }
`;

export default function Detail() {
    const { revitParameterTemplateID } = useParams();

    const revitParameterTemplate = useRevitParameterTemplate(revitParameterTemplateID);

    if (revitParameterTemplate.loading) return "loading ...";
    if (revitParameterTemplate.error) return "error";

    const { revitBuiltInParameterID, revitSharedParameterDefinition } = revitParameterTemplate.data.revitParameterTemplate;
    let Attributes: ElementType = () => undefined;
    if (revitBuiltInParameterID) Attributes = RevitBuiltInParameterAssignment;
    if (revitSharedParameterDefinition) Attributes = SharedParameterAttributes;

    return (
        <StyledDetail>
            <Background position="bottom right" text="revit parameter template" />
            <Back to=".." />
            <header>
                <Parameter id={ revitParameterTemplate.data.revitParameterTemplate.parameterID } />
                <BIMClass id={ revitParameterTemplate.data.revitParameterTemplate.bimClassID } />
            </header>
            <Attributes { ...(revitBuiltInParameterID ? { id: revitBuiltInParameterID } : revitSharedParameterDefinition) } />
            <Delete
                __typename={ revitParameterTemplate.data.revitParameterTemplate.__typename }
                id={ revitParameterTemplateID }
            />
        </StyledDetail>
    );
}
